import { Tab, TabGroup, TabList } from '@headlessui/react'
import { useMemo } from 'react'
import { useAnal } from '../../../hooks'

export const Tabs = <GTabs extends Record<string, React.ReactNode>>(props: {
  selectedTab?: string
  tabs: GTabs
  classNameWrapper?: string
  classNameTabList?: string
  classNameTab?: string
  onChange: (tab: keyof GTabs) => void
}) => {
  const { logEvent } = useAnal()

  const tabs = useMemo(() => Object.entries(props.tabs), [props.tabs])

  const defaultTabIndex = useMemo(
    () =>
      props.selectedTab !== undefined
        ? tabs.findIndex(([name, _component]) => name === props.selectedTab)
        : undefined,
    [props.selectedTab, tabs],
  )

  const onChange = (tab: keyof GTabs) => {
    logEvent('ui_button_click', {
      name: tab.toString().toLowerCase(),
      type: 'tab',
    })
    props.onChange(tab)
  }

  return (
    <TabGroup
      className={props.classNameWrapper}
      selectedIndex={defaultTabIndex}
      onChange={(index) => onChange(tabs[index][0])}
    >
      <TabList className={props.classNameTabList}>
        {tabs.map(([tab, content]) => (
          <Tab
            key={tab}
            className={props.classNameTab}
          >
            {content}
          </Tab>
        ))}
      </TabList>
    </TabGroup>
  )
}
